import { Routes } from '@angular/router';
import { LoginDialogResponse } from './login-dialog-response/login-dialog-response';
import { LoginDialog } from './login-dialog/login-dialog';
import { Login } from './login/login';

/** Login page and the Office dialog routes, spread into each add-in's route table. */
export const oauthRoutes: Routes = [
  {
    path: 'login',
    component: Login
  },
  {
    path: 'oauth',
    data: { hideTenantBar: true, hideShell: true },
    children: [
      {
        path: 'login',
        component: LoginDialog
      },
      {
        path: 'cb',
        component: LoginDialogResponse
      }
    ]
  }
];
